export default __webpack_public_path__ + "static/media/icon-bookmark.a86687ae.svg";